// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3WMzQ","info":"PatientInfo_info__2TCFI"};